module.exports = __webpack_public_path__ + "static/CLICK_HeroVideo-673f60602d943b8da7503b724fda57eb.mp4";